import { Flex, Skeleton, Text, Balance, Pool, Box } from '@pancakeswap/uikit'
import styled from 'styled-components'
import { useTranslation } from '@pancakeswap/localization'
import { Token } from '@pancakeswap/sdk'
import BigNumber from 'bignumber.js'
import useBUSDPrice from 'hooks/useBUSDPrice'
import { getBalanceNumber } from '@pancakeswap/utils/formatBalance'

interface TotalStakedCellProps {
  totalStakedBalance: number
  stakingToken: Token
  totalStaked: BigNumber
  locked?: boolean
}

const StyledCell = styled(Pool.BaseCell)`
  flex: 2 0 100px;
`

const TotalStakedCell: React.FC<React.PropsWithChildren<TotalStakedCellProps>> = ({
  stakingToken,
  totalStaked,
  totalStakedBalance,
}) => {
  const { t } = useTranslation()
  const stakingTokenPriceUSD = useBUSDPrice(stakingToken)
  const totalStakedUSD = getBalanceNumber(
    totalStaked.multipliedBy(stakingTokenPriceUSD?.toFixed(18)),
    stakingToken.decimals,
  )

  return (
    <StyledCell role="cell">
      <Pool.CellContent>
        <Text fontSize="12px" color="textSubtle" textAlign="left">
          {t(`Total staked`)}
        </Text>
        {totalStaked && totalStaked.gte(0) ? (
          <Flex>
            <Box mr="8px" height="32px">
              <Balance fontSize="16px" mt="4px" value={totalStakedBalance} decimals={0} unit={` ${stakingToken.symbol}`} />
              <Balance
                display="inline"
                fontSize="12px"
                color="textSubtle"
                decimals={2}
                prefix="~"
                value={totalStakedUSD}
                unit=" USD"
              />
            </Box>
          </Flex>
        ) : (
          <Skeleton width="80px" height="16px" />
        )}
      </Pool.CellContent>
    </StyledCell>
  )
}

export default TotalStakedCell
